import { useEffect, useState } from 'react';

import { DeepPartial, HeatPumpOutdoorUnit, ProductTypes, Residence, TakeoverType } from '~src/model';
import { isResidenceFilled } from '~src/util';

import { useCheapestOutdoorUnitPerBrand } from './useCheapestOutdoorUnitPerBrand';

export const useTakeover = (
  residence?: DeepPartial<Residence>,
  inputOutdoorUnits: HeatPumpOutdoorUnit[] = [],
  selectedProductTypes?: ProductTypes
) => {
  const [takeover, setTakeover] = useState<TakeoverType>();

  const outdoorUnits = useCheapestOutdoorUnitPerBrand(residence, inputOutdoorUnits);

  useEffect(() => {
    if (residence?.type === 'apartment') {
      setTakeover('apartment');
      return;
    }

    // Remove takeover if offer is strictly 'solar' and residence is not 'apartment'
    if (selectedProductTypes?.length === 1 && selectedProductTypes.includes('solar')) {
      setTakeover(undefined);
      return;
    }

    const { primaryHeating } = residence ?? {};
    const { fuelType, heatSource } = primaryHeating ?? {};

    if (['straw', 'electricity', 'districtHeating'].includes(fuelType ?? '') || heatSource?.includes('heatPump-')) {
      setTakeover('invalidHeating');
      return;
    }

    if (isResidenceFilled(residence) && outdoorUnits.length === 0) {
      setTakeover('highUsage');
      return;
    }

    setTakeover(undefined);
  }, [residence, outdoorUnits.length, selectedProductTypes]);

  return takeover;
};
